import styled from 'styled-components';

const AdminWrapper = styled.div``;

export { AdminWrapper };
